


















import ripple from "./ripple.vue";
import loadingBar from "./loadingBar.vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";

@Component({
    components: {
        ripple,
        loadingBar
    }
})
export default class GlobalLoad extends Vue {

    @Prop({}) perc:number;
    loadPerc = this.perc;

    @Watch('perc')
    updateLoadPerc(to, from){
        this.loadPerc = this.perc;

        if(this.perc >= 100){
            let wrapper = this.$refs.wrapper as HTMLDivElement
            wrapper.style.opacity = "0";
            setTimeout(() => {
                wrapper.style.display = "none";
            },1000);
        }
    }
    
}

